import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Services from './components/Services';
import Pickup from './components/Pickup';
import About from './components/About';
import Locations from './components/Locations';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-brand/20 selection:text-brand-dark">
      <Header />
      <main>
        <Hero />
        <Features />
        <Services />
        <Pickup />
        <About />
        <Locations />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
